import { render, staticRenderFns } from "./ListSitucontratoPage.vue?vue&type=template&id=15919d3e&"
import script from "./ListSitucontratoPage.vue?vue&type=script&lang=js&"
export * from "./ListSitucontratoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports